import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useMemo, useState } from "react";
import toast from "react-hot-toast";
import { useSelector, useDispatch } from "react-redux";
import { verifyPayPalOrder } from "../../../../store/reducers/reducerPayPal";
import Scrollto from "../../../tools/scrollTo";

import "./buyCredits.scss";

/** Display + PayPal createOrder only. Server maps paid USD → BCoin. */
const BCOIN_PACKAGES = [
  { id: 1, bcoin: 1000, price: "34.99" },
  { id: 2, bcoin: 3000, price: "99.99" },
  { id: 3, bcoin: 5000, price: "169.99" },
];

const BuyCredits = () => {
  const user = useSelector((state) => state.reducerUser.userLogin.data);
  const dispatch = useDispatch();

  const [selectedPackageId, setSelectedPackageId] = useState(1);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [orderId, setOrderId] = useState(false);

  const selectedPackage = useMemo(
    () =>
      BCOIN_PACKAGES.find((p) => p.id === selectedPackageId) ||
      BCOIN_PACKAGES[0],
    [selectedPackageId]
  );

  const createOrder = (_data, actions) => {
    const pkg = selectedPackage;
    return actions.order
      .create({
        purchase_units: [
          {
            description: `${pkg.bcoin} BCoin`,
            custom_id: `bcoin_pkg_${pkg.id}`,
            amount: {
              currency_code: "USD",
              value: pkg.price,
            },
          },
        ],
        application_context: {
          shipping_preference: "NO_SHIPPING",
        },
      })
      .then((orderID) => {
        setOrderId(orderID);
        return orderID;
      });
  };

  const onApprove = (data, actions) => {
    return actions.order.capture().then(async function () {
      const capturedOrderId = data.orderID;

      try {
        dispatch(
          await verifyPayPalOrder({
            orderId: capturedOrderId,
            username: user.username,
          })
        ).then(function (response) {
          if (response.error) {
            const payload = response.payload;
            toast.error(
              typeof payload === "string"
                ? payload
                : "Failed to verify PayPal payment"
            );
            return;
          }

          toast.success(<div>BCoin have been added to your account!</div>);
        });

        setSuccess(true);
      } catch (err) {
        console.error("Error verifying PayPal order:", err);
      }
    });
  };

  const onError = () => {
    setErrorMessage("");
  };

  return (
    <div className="buyCreditsContainer">
      <Scrollto position={200} />
      <PayPalScriptProvider
        options={{
          "client-id": process.env.REACT_APP_PAY_PAL_SERIAL,
        }}
      >
        <div className="buyCreditsUserCredits">
          Your BCoin : {user?.data?.[0]?.BCoin ?? 0}
          <br />
          Your Credits : {user?.data?.[0]?.Credits ?? 0}
        </div>
        <h1 className="buyCreditsTitle">Buy BCoin</h1>
        <div className="linePage"></div>

        {BCOIN_PACKAGES.map((pkg) => (
          <div className="containerBtnBuyCredits" key={pkg.id}>
            <span>
              {pkg.bcoin.toLocaleString("en-US")} BCoin &nbsp;
            </span>
            <button
              onClick={() => {
                setSelectedPackageId(pkg.id);
                setSuccess(false);
              }}
              type="button"
            >
              Buy Now
            </button>
          </div>
        ))}

        {!success ? (
          <div className="payPallBtns">
            <h1>
              {selectedPackage.bcoin} BCOIN - ${selectedPackage.price}
            </h1>
            <PayPalButtons
              key={selectedPackage.id}
              style={{ layout: "vertical" }}
              createOrder={createOrder}
              onApprove={onApprove}
              onError={onError}
            />
          </div>
        ) : null}

        {errorMessage ? null : null}
        {orderId ? null : null}
      </PayPalScriptProvider>
    </div>
  );
};

export default BuyCredits;
